import { render, staticRenderFns } from "./PublicInfo.vue?vue&type=template&id=1843bac9&"
import script from "./PublicInfo.vue?vue&type=script&lang=ts&"
export * from "./PublicInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports